<div class="return-recovery-payment-container">
  <div class="return-recovery-payment-container-header">
    {{ 'manage-recovery-payment-return' | translate }}
  </div>
  <div class="input-title-name">{{ 'manage-recovery-payment-return-comments' | translate }}</div>
  <div class="return-recovery-payment-container-comment">
      <textarea class="return-recovery-payment-container-comment-input"
                maxlength="255"
                [(ngModel)]="returnRemark">
      </textarea>
  </div>
  <div class="return-recovery-payment-container-footer">
    <button class="return-recovery-payment-container-footer-button-return" (click)="returnToAccounting()"
            [class.return-recovery-payment-container-footer-button-return-disabled]="!returnRemark"
            [disabled]="!returnRemark">{{ 'manage-recovery-payment-return' | translate }}
    </button>
    <button class="return-recovery-payment-container-footer-button"
            (click)="close()">{{ 'message-dialog-close-and-discard' | translate }}
    </button>
  </div>
</div>
